/**
 * ProTurbo Wishlist System
 * localStorage based - works for all visitors (guest + logged in)
 */

(function () {
  const STORAGE_KEY = 'proturbo_wishlist';

  /* ─── Core helpers ─── */
  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {}
  }

  function isInWishlist(productId) {
    return getWishlist().some(function (item) {
      return String(item.id) === String(productId);
    });
  }

  function addToWishlist(productData) {
    var items = getWishlist();
    if (!isInWishlist(productData.id)) {
      items.push(productData);
      saveWishlist(items);
    }
  }

  function removeFromWishlist(productId) {
    var items = getWishlist().filter(function (item) {
      return String(item.id) !== String(productId);
    });
    saveWishlist(items);
  }

  /* ─── Update all buttons for a given productId ─── */
  function updateAllButtons(productId) {
    var inList = isInWishlist(productId);
    document.querySelectorAll('[data-wishlist-btn][data-product-id="' + productId + '"]').forEach(function (btn) {
      btn.classList.toggle('wishlist-btn--active', inList);
      btn.setAttribute('aria-label', inList ? 'Remove from Wishlist' : 'Add to Wishlist');
      btn.setAttribute('title', inList ? 'Remove from Wishlist' : 'Add to Wishlist');

      var textEl = btn.querySelector('.wishlist-btn__text');
      if (textEl) {
        textEl.textContent = inList ? 'Remove from Wishlist' : 'Add to Wishlist';
      }

      var iconEl = btn.querySelector('.wishlist-btn__icon');
      if (iconEl) {
        iconEl.innerHTML = inList ? heartFilledSVG() : heartOutlineSVG();
      }
    });

    // Update counter badge in header
    updateHeaderCounter();
  }

  /* ─── Update header counter ─── */
  function updateHeaderCounter() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'inline-flex' : 'none';
    });
  }

  /* ─── SVG icons ─── */
  function heartOutlineSVG() {
    return '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>';
  }

  function heartFilledSVG() {
    return '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>';
  }

  /* ─── Init wishlist buttons on any page ─── */
  function initButtons() {
    document.querySelectorAll('[data-wishlist-btn]').forEach(function (btn) {
      var productId = btn.getAttribute('data-product-id');
      if (!productId) return;

      // Set initial state
      updateAllButtons(productId);

      // Prevent duplicate listeners
      if (btn.dataset.wishlistInit) return;
      btn.dataset.wishlistInit = '1';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var id      = btn.getAttribute('data-product-id');
        var title   = btn.getAttribute('data-product-title');
        var price   = btn.getAttribute('data-product-price');
        var image   = btn.getAttribute('data-product-image');
        var url     = btn.getAttribute('data-product-url');
        var handle  = btn.getAttribute('data-product-handle');

        if (isInWishlist(id)) {
          removeFromWishlist(id);
        } else {
          addToWishlist({ id: id, title: title, price: price, image: image, url: url, handle: handle });
          showToast(title);
        }
        updateAllButtons(id);
      });
    });
  }

  /* ─── Toast notification ─── */
  function showToast(productTitle) {
    var existing = document.getElementById('wishlist-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.id = 'wishlist-toast';
    toast.innerHTML = heartFilledSVG() + '<span>Added to Wishlist!</span>';
    document.body.appendChild(toast);

    // Trigger animation
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        toast.classList.add('wishlist-toast--show');
      });
    });

    setTimeout(function () {
      toast.classList.remove('wishlist-toast--show');
      setTimeout(function () { toast.remove(); }, 400);
    }, 2500);
  }

  /* ─── Render wishlist PAGE ─── */
  function renderWishlistPage() {
    var container = document.getElementById('wishlist-page-container');
    if (!container) return;

    var items = getWishlist();

    if (items.length === 0) {
      container.innerHTML = '<div class="wishlist-empty"><div class="wishlist-empty__icon">' + heartOutlineSVG() + '</div><p class="wishlist-empty__text">Your wishlist is empty.</p><a href="/" class="button button--primary wishlist-empty__btn">Continue Shopping</a></div>';
      return;
    }

    var html = '<div class="wishlist-grid">';

    items.forEach(function (item) {
      var priceNum  = parseInt(item.price, 10);
      var formatted = isNaN(priceNum) ? item.price : (window.theme && window.theme.moneyFormat
        ? window.theme.moneyFormat.replace('{{amount}}', (priceNum / 100).toFixed(2))
          .replace('{{amount_no_decimals}}', Math.floor(priceNum / 100))
        : '$' + (priceNum / 100).toFixed(2));

      html += '<div class="wishlist-card" data-product-id="' + item.id + '">';
      html += '<a href="' + item.url + '" class="wishlist-card__image-link">';
      if (item.image) {
        html += '<img class="wishlist-card__image" src="' + item.image + '" alt="' + (item.title || '') + '" loading="lazy">';
      } else {
        html += '<div class="wishlist-card__no-image">' + heartOutlineSVG() + '</div>';
      }
      html += '</a>';
      html += '<div class="wishlist-card__body">';
      html += '<a href="' + item.url + '" class="wishlist-card__title">' + item.title + '</a>';
      html += '<p class="wishlist-card__price">' + formatted + '</p>';
      html += '<div class="wishlist-card__actions">';
      html += '<a href="' + item.url + '" class="button button--primary wishlist-card__atc-btn">View Product</a>';
      html += '<button class="wishlist-card__remove-btn" data-wishlist-remove="' + item.id + '" aria-label="Remove from wishlist" title="Remove">';
      html += '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6l-1 14H6L5 6"></path><path d="M10 11v6"></path><path d="M14 11v6"></path><path d="M9 6V4h6v2"></path></svg>';
      html += '</button>';
      html += '</div></div></div>';
    });

    html += '</div>';
    container.innerHTML = html;

    // Remove button listeners
    container.querySelectorAll('[data-wishlist-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-wishlist-remove');
        removeFromWishlist(id);
        renderWishlistPage();
        updateHeaderCounter();
      });
    });
  }

  /* ─── Boot ─── */
  function init() {
 try {
    initButtons();
    updateHeaderCounter();
    renderWishlistPage();
  } catch (e) {
    console.error('Wishlist error:', e);
  }

   // Only observe wishlist container pages, not product page
if (!document.body.classList.contains('template-product')) {
  var observer = new MutationObserver(function () {
    initButtons();
  });
  observer.observe(document.body, { childList: true, subtree: true });
}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose globally if needed
  window.ProturboWishlist = {
    getWishlist: getWishlist,
    addToWishlist: addToWishlist,
    removeFromWishlist: removeFromWishlist,
    isInWishlist: isInWishlist
  };
})();
